import { useParams, useNavigate } from "react-router-dom";
import { useQuery, useMutation } from "@tanstack/react-query";
import {
  fetchImageCaptureAccountById,
  deleteImageCaptureAccountById,
} from "./../../../../lib/api/resources/imageCaptureAccounts";
import { ImageCaptureAccountDetailCard } from "./components/ImageCaptureAccountDetailCard";
import { Col, Flex, message, Row } from "antd";

export const ImageCaptureAccountDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ["imageCaptureAccount", id],
    queryFn: () => fetchImageCaptureAccountById(id!),
  });

  const deleteMutation = useMutation({
    mutationFn: () => deleteImageCaptureAccountById(id!),
    onSuccess: () => {
      navigate("/image-captures/accounts");
      message.success("ImageCapture account succesvol verwijderd");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het verwijderen van het ImageCapture account",
      ),
  });

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Flex vertical gap={16}>
          <ImageCaptureAccountDetailCard
            deleteMutation={deleteMutation}
            account={data}
            isLoading={isLoading}
          />
        </Flex>
      </Col>
    </Row>
  );
};
